import { getInstance } from '@components/DependencyInjectionContainer.js';
import { forEachKey, isArray, sortBy } from '@components/Utility/index.js';
import { combineLatest } from 'rxjs';
import { DataRecord } from '@components/DataRecord/DataRecord.js';
function escapeRegExp(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
export function TokenAutoCompleteMixin(classToExtend) {
    return class extends classToExtend {
        constructor() {
            super(...arguments);
            this.currentActiveAutoCompleteMenu = false;
            this._autoCompleteTokens = [
            // {value: 'test', display: 'Test'}
            // ,{value: 'tast', display: 'tast'}
            ];
            this._autoCompleteTokenValueKey = '';
            this._autoCompleteTokenDisplayKey = '';
            this._activeFragmentRange = null;
            this._autoCompleteOptions = {
                trigger: '{{',
                closeWith: '}}',
                minChars: 0,
                caseInsensitive: true,
                maxScanBack: 300,
                includeCloseOnInsert: true,
                allowPartialReplace: true,
                filterContains: true
            };
            this.handleAutocompleteMenuHotkeySync = (e) => {
                if (!this.menuOpen)
                    return;
                const key = e.key.toLowerCase();
                const map = {
                    'arrowup': 'arrowup',
                    'arrowdown': 'arrowdown',
                    // 'arrowleft': 'arrowleft',
                    // 'arrowright': 'arrowright',
                    'enter': 'enter',
                    'escape': 'escape'
                };
                const hkKey = map[key];
                if (!hkKey)
                    return;
                const cm = this.ContextMenu; // your class exposes `hotkeys`
                const handler = cm?.hotkeys?.[hkKey];
                if (typeof handler === 'function') {
                    const handled = handler.call(this.ContextMenu, e, hkKey);
                    if (handled !== false) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
                // if (key === 'escape') {
                // 	this.closeAutocompleteMenu();
                // 	e.preventDefault();
                // 	e.stopPropagation();
                // }
            };
        }
        get autoCompleteTokens() { return this._autoCompleteTokens; }
        set autoCompleteTokens(t) {
            this._propertySet('autoCompleteTokens', t);
        }
        get autoCompleteTokenDatasourceId() { return this._autoCompleteTokenDatasourceId; }
        set autoCompleteTokenDatasourceId(t) {
            this._propertySet('autoCompleteTokenDatasourceId', t);
            if (this.drawn) {
                this.awaitAutoCompleteDatasource();
            }
        }
        get autoCompleteTokenDatasourceComponent() { return this._autoCompleteTokenDatasourceComponent; }
        set autoCompleteTokenDatasourceComponent(t) {
            this._propertySet('autoCompleteTokenDatasourceComponent', t);
            if (t) {
                this.listenForAutocompleteTokens(t);
            }
        }
        get autoCompleteTokenValueKey() { return this._autoCompleteTokenValueKey; }
        set autoCompleteTokenValueKey(t) {
            this._propertySet('autoCompleteTokenValueKey', t);
        }
        get autoCompleteTokenDisplayKey() { return this._autoCompleteTokenDisplayKey; }
        set autoCompleteTokenDisplayKey(t) {
            this._propertySet('autoCompleteTokenDisplayKey', t);
        }
        get autoCompleteOptions() { return this._autoCompleteOptions; }
        set autoCompleteOptions(t) {
            this._propertySet('autoCompleteOptions', t);
        }
        setAutoCompleteOptions(opts) {
            Object.assign(this._autoCompleteOptions, opts || {});
        }
        get ContextMenu() {
            return getInstance('ContextMenu');
        }
        get menuOpen() { return this.currentActiveAutoCompleteMenu && !this.ContextMenu.hidden; }
        get tokenHostPort() { return this._tokenHostPort; }
        set tokenHostPort(t) {
            this._propertySet('tokenHostPort', t);
        }
        handleFocus(event) {
            super.handleFocus(event);
            if (!this.autoCompleteInputEventId && this.focused && this._autoCompleteTokens.length) {
                this.enableTokenAutocomplete();
            }
        }
        handleBlur(event) {
            super.handleBlur(event);
            if (this.autoCompleteInputEventId
                && !this.focused
                && (!event.relatedTarget
                    // clicking the menu was defocusing the input before the insert token ran
                    || !this.ContextMenu.rootElement.contains(event.relatedTarget))) {
                this.disableTokenAutocomplete();
            }
        }
        enableTokenAutocomplete() {
            this.registerTokenAutocomplete(this.autoCompleteHandleInput.bind(this));
        }
        disableTokenAutocomplete() {
            this.unRegisterTokenAutocomplete();
            this.closeAutocompleteMenu();
        }
        registerTokenAutocomplete(fnCallBack) {
            if (this._tokenHostPort?.element) {
                this.autoCompleteInputEventId = this.registerEvent('input', this._tokenHostPort.element, fnCallBack, { capture: true });
            }
        }
        unRegisterTokenAutocomplete() {
            if (this.autoCompleteInputEventId) {
                this.unRegisterEvent(this.autoCompleteInputEventId);
                delete this.autoCompleteInputEventId;
            }
        }
        autoCompleteHandleInput(_ev) {
            this.maybeOpenOrUpdateAutocompleteMenu();
        }
        maybeOpenOrUpdateAutocompleteMenu() {
            const { fragment, fragmentRange } = this.findActiveAutocompleteFragment();
            if (typeof fragment !== 'string' || fragment.length < this._autoCompleteOptions.minChars) {
                this.closeAutocompleteMenu();
                return;
            }
            const items = this.filterAutocompleteTokens(fragment);
            if (!items.length) {
                this.closeAutocompleteMenu();
                return;
            }
            this._activeFragmentRange = fragmentRange;
            this.openAutocompleteMenu(items);
        }
        filterAutocompleteTokens(fragment) {
            const f = this._autoCompleteOptions.caseInsensitive ? fragment.toLowerCase() : fragment;
            return this._autoCompleteTokens.filter(t => {
                const hay = this._autoCompleteOptions.caseInsensitive ? t.value.toLowerCase() : t.value;
                return this._autoCompleteOptions.filterContains ? hay.indexOf(f) > -1 : hay.startsWith(f);
            }).slice(0, 100);
        }
        findActiveAutocompleteFragment() {
            const port = this._tokenHostPort;
            if (!port) {
                return {
                    fragment: null,
                    fragmentRange: {
                        start: 0,
                        end: 0
                    }
                };
            }
            const sel = port.getSelection();
            const text = port.getText();
            const caret = sel.start;
            const startScan = Math.max(0, caret - this._autoCompleteOptions.maxScanBack);
            const before = text.slice(startScan, caret);
            const trig = escapeRegExp(this._autoCompleteOptions.trigger);
            // stop on whitespace OR any char from closeWith
            const stopperChars = Array.from(this._autoCompleteOptions.closeWith).map(escapeRegExp).join('');
            const re = new RegExp(`${trig}([^\\s${stopperChars}]*)$`);
            const m = before.match(re);
            if (!m)
                return { fragment: null, fragmentRange: { start: sel.start, end: sel.start } };
            const fragment = m[1] || '';
            const fragStart = caret - m[0].length;
            const fragEnd = caret;
            const start = this._autoCompleteOptions.allowPartialReplace ? fragStart : (fragStart + this._autoCompleteOptions.trigger.length);
            return { fragment, fragmentRange: { start, end: fragEnd } };
        }
        insertAutocompleteToken(tokenValue) {
            const port = this._tokenHostPort;
            if (!this._activeFragmentRange || !port)
                return;
            const insertText = this._autoCompleteOptions.includeCloseOnInsert
                ? `${this._autoCompleteOptions.trigger}${tokenValue}${this._autoCompleteOptions.closeWith}`
                : `${this._autoCompleteOptions.trigger}${tokenValue}`;
            port.replaceRange(this._activeFragmentRange, insertText);
            port.focus();
            this.closeAutocompleteMenu();
        }
        /** ContextMenu wiring */
        openAutocompleteMenu(items) {
            const port = this._tokenHostPort;
            if (!port)
                return;
            const rect = port.getCaretClientRect();
            const ctxMenu = this.ContextMenu;
            const menuItems = items.map(i => ({
                caption: i.display ?? i.value,
                onClick: () => this.insertAutocompleteToken(i.value)
            }));
            // ContextMenu wants a ContextMenuInfoInterface with an Event having stopImmediatePropagation
            const fakeEvent = Object.assign(new MouseEvent('click', { clientX: rect.left, clientY: rect.bottom }), { stopImmediatePropagation: () => { } });
            const info = {
                event: fakeEvent,
                x: rect.left,
                y: rect.bottom,
                anchorPosition: 'top-left',
                initiator: this,
                targetElement: port.element || this.rootElement,
                autocomplete: true
            };
            ctxMenu.showMenu(menuItems, info);
            this.currentActiveAutoCompleteMenu = true;
            this.registerAutocompleteMenuHotkeysSync();
        }
        closeAutocompleteMenu() {
            this.currentActiveAutoCompleteMenu = false;
            this.unRegisterAutocompleteMenuHotkeysSync();
            if (!this.menuOpen)
                return;
            this.ContextMenu.hide();
            this._activeFragmentRange = null;
        }
        registerAutocompleteMenuHotkeysSync() {
            if (this.autocompleteKeydownEventId)
                return;
            this.autocompleteKeydownEventId = this.registerEvent('keydown', document, this.handleAutocompleteMenuHotkeySync, { capture: true });
        }
        unRegisterAutocompleteMenuHotkeysSync() {
            if (!this.autocompleteKeydownEventId)
                return;
            this.unRegisterEvent(this.autocompleteKeydownEventId);
            this.autocompleteKeydownEventId = undefined;
        }
        draw() {
            super.draw();
            if (this.autoCompleteTokenDatasourceId) {
                this.awaitAutoCompleteDatasource();
            }
        }
        awaitAutoCompleteDatasource() {
            if (this.formContext && this._autoCompleteTokenDatasourceId) {
                this.formContext.componentGet$(this._autoCompleteTokenDatasourceId)
                    .subscribe((component) => {
                    this.autoCompleteTokenDatasourceComponent = component;
                });
            }
        }
        listenForAutocompleteTokens(list) {
            combineLatest([
                list.propertyGet$('staticOptionData'),
                list.propertyGet$('optionData')
            ]).subscribe(([staticOptionData, optionData]) => {
                const tokens = [...staticOptionData];
                const valuekey = this.autoCompleteTokenValueKey || 'value';
                let displayKey = this.autoCompleteTokenDisplayKey || valuekey;
                if (!isArray(displayKey)) {
                    displayKey = [displayKey];
                }
                if (!displayKey.length) {
                    displayKey = [valuekey];
                }
                optionData.forEach((opt) => {
                    if (opt instanceof DataRecord) {
                        opt = opt.data;
                    }
                    if (opt[valuekey]) {
                        let value = String(opt[valuekey]);
                        if (value.startsWith('{{') && value.endsWith('}}')) {
                            value = value.slice(2, -2);
                        }
                        tokens.push({
                            value,
                            display: (displayKey.map((key) => {
                                return opt[key] || '';
                            }).join(' - '))
                        });
                    }
                });
                this.autoCompleteTokens = sortBy(tokens, opt => opt.display, 'asc');
            });
        }
        formDesignerPropertiesGet(properties) {
            properties = super.formDesignerPropertiesGet(properties);
            const options = [{ value: '', display: '' }];
            forEachKey(this.formContext?.componentsGet() || {}, (component) => {
                if (component.propertyGet('optionData') || component.propertyGet('staticOptionData')) {
                    options.push({
                        value: component.id,
                        display: `${component.id} - ${component.propertyGet('endpoint')} - ${component.propertyGet('action')}`
                    });
                }
            });
            properties.autoCompleteTokenDatasourceId = {
                id: 'autoCompleteTokenDatasourceId',
                value: this.autoCompleteTokenDatasourceId,
                componentType: 'Select',
                componentProperties: {
                    staticOptionData: options,
                    labelWidth: 'auto'
                },
                captionKey: 'formbuilder_autocomplete_datasourceid',
                propertyGroup: 'autocomplete',
                propertyIndex: 1,
                saveFlag: !!this.autoCompleteTokenDatasourceId
            };
            properties.autoCompleteTokenValueKey = {
                id: 'autoCompleteTokenValueKey',
                value: this.autoCompleteTokenValueKey,
                componentType: 'Input',
                componentProperties: {
                    labelWidth: 'auto'
                },
                captionKey: 'formbuilder_autocomplete_tokenvaluekey',
                propertyGroup: 'autocomplete',
                propertyIndex: 2,
                saveFlag: !!this.autoCompleteTokenValueKey
            };
            let val = this.autoCompleteTokenDisplayKey;
            if (isArray(val) && val.length < 2) {
                val = val.length === 1 ? val[0] : '';
            }
            properties.autoCompleteTokenDisplayKey = {
                id: 'autoCompleteTokenDisplayKey',
                value: this.autoCompleteTokenDisplayKey,
                componentType: 'Select',
                componentProperties: {
                    multiSelectValueType: 'ARRAY',
                    allowFreeFormEntry: true,
                    multiSelect: true,
                    multiSelectDragToSort: true,
                    labelWidth: 'auto'
                },
                captionKey: 'formbuilder_autocomplete_tokendisplaykey',
                propertyGroup: 'autocomplete',
                propertyIndex: 3,
                saveFlag: !!this.autoCompleteTokenDisplayKey
            };
            return properties;
        }
        destroy() {
            this.disableTokenAutocomplete();
            delete this._tokenHostPort;
            this._autoCompleteTokens.length = 0;
            delete this._autoCompleteTokenDatasourceComponent;
            super.destroy();
        }
    };
}
